/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from './StatusBadge';
import { JOB_OPENING_STATUS_LABEL } from '../constants';

// Status da vaga. Aberta = verde; congelada = âmbar; encerrada = vermelha;
// preenchida = azul.
const STATUS_VARIANT = {
   ABERTA: 'green',
   CONGELADA: 'amber',
   ENCERRADA: 'red',
   PREENCHIDA: 'blue',
};

export default function JobOpeningStatusBadge({ value }) {
   return (
      <StatusBadge variant={STATUS_VARIANT[value] ?? 'neutral'}>
         {JOB_OPENING_STATUS_LABEL[value] ?? value ?? '—'}
      </StatusBadge>
   );
}

JobOpeningStatusBadge.propTypes = {
   value: PropTypes.string,
};
